import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CartState } from '@app/store/state/cart.state';
import { NgxsModule } from '@ngxs/store';

import { SelectionComponent } from './selection.component';

export const routes = [
  {
    path: '',
    component: SelectionComponent,
    children: [
      {
        path: 'swiss_backup',
        loadChildren: () => import('./swiss-backup/swiss-backup.module').then((m) => m.SwissBackupModule),
      },
      {
        path: 'swiss_backup_change_offer',
        loadChildren: () =>
          import('./swiss-backup/change-offer/swiss-backup-change-offer.module').then(
            (m) => m.SwissBackupChangeOfferModule
          ),
      },
      {
        path: 'nas',
        loadChildren: () => import('./nas/nas.module').then((m) => m.NasModule),
      },
      {
        path: 'jelastic',
        loadChildren: () => import('./jelastic/jelastic.module').then((m) => m.JelasticModule),
      },
      {
        path: 'invitation_change_offer',
        loadChildren: () => import('./invitation/invitation.module').then((m) => m.InvitationModule),
      },
      {
        path: 'newsletter',
        loadChildren: () => import('./newsletter/newsletter.module').then((m) => m.NewsletterModule),
      },
      {
        path: 'mailing',
        loadChildren: () => import('./mailing/mailing.module').then((m) => m.MailingModule),
      },
      {
        path: 'drive',
        loadChildren: () => import('./drive/drive.module').then((m) => m.DriveModule),
      },
      {
        path: 'jelastic',
        loadChildren: () => import('./jelastic/jelastic.module').then((m) => m.JelasticModule),
      },
      {
        path: 'drive_change_offer',
        loadChildren: () =>
          import('./drive/change-offer/drive-change-offer.module').then((m) => m.SwissBackupChangeOfferModule),
      },
      {
        path: 'mail_change_offer',
        loadChildren: () =>
          import('./service-mail/change-offer/service-mail-change-offer.module').then(
            (m) => m.ServiceMailChangeOfferModule
          ),
      },
      {
        path: 'vod',
        loadChildren: () => import('./vod/vod.module').then((m) => m.VodModule),
      },
      {
        path: 'vod_change_offer',
        loadChildren: () => import('./vod/change-offer/vod-change-offer.module').then((m) => m.VodChangeOfferModule),
      },
      ...['bulk_transfer_domain', 'bulk_registration_domain'].map((path) => ({
        path,
        loadChildren: () =>
          import('./bulk-transfer-domain/bulk-transfer-domain.module').then((m) => m.BulkTransferDomainModule),
      })),
      {
        path: 'streaming_video',
        loadChildren: () => import('./streaming-video/video.module').then((m) => m.VideoModule),
      },
      {
        path: 'streaming_video_change_offer',
        loadChildren: () =>
          import('./streaming-video/change-offer/video-change-offer.module').then((m) => m.VideoChangeOfferModule),
      },
      ...['domain', 'domain_ksite', 'dns', 'dns_free'].map((path) => ({
        path,
        loadChildren: () => import('./domain/domain.module').then((m) => m.DomainModule),
      })),
      ...['hosting', 'email_hosting', 'vps'].map((path) => ({
        path,
        loadChildren: () =>
          import('../recommendation/new-domain-recommendation/new-domain-recommendation.module').then(
            (m) => m.NewDomainRecommendationModule
          ),
      })),
      {
        path: 'vps_only',
        loadChildren: () => import('./vps/vps.module').then((m) => m.VpsModule),
      },
      {
        path: 'vps_change_offer',
        loadChildren: () => import('./vps/change-offer/vps-change-offer.module').then((m) => m.VpsChangeOfferModule),
      },
      {
        path: 'website_builder',
        loadChildren: () => import('./site-builder/site-builder.module').then((m) => m.SiteBuilderModule),
      },
      {
        path: 'website_builder_change_offer',
        loadChildren: () =>
          import('./site-builder/change-offer/site-builder-change-offer.module').then(
            (m) => m.SiteBuilderChangeOfferModule
          ),
      },
      {
        path: 'public_cloud',
        loadChildren: () => import('./public-cloud/public-cloud.module').then((m) => m.PublicCloudModule),
      },
      {
        path: 'ksuite',
        loadChildren: () => import('./ksuite/ksuite/ksuite.module').then((m) => m.KsuiteModule),
      },
      {
        path: 'my_ksuite',
        loadChildren: () => import('./ksuite/myksuite/myksuite.module').then((m) => m.MyKSuiteModule),
      },
      {
        path: 'ksuite_change_offer',
        loadChildren: () =>
          import('./ksuite/change-offer/ksuite-change-offer.module').then((m) => m.KsuiteChangeOfferModule),
      },
      {
        path: 'my_ksuite_change_offer',
        loadChildren: () =>
          import('./ksuite/myksuite/myksuite-change-offer/myksuite-change-offer.module').then(
            (m) => m.MyksuiteChangeOfferModule
          ),
      },
      {
        path: 'streaming_audio',
        loadChildren: () => import('./streaming-audio/radio.module').then((m) => m.RadioModule),
      },
      {
        path: 'streaming_audio_change_offer',
        loadChildren: () =>
          import('./streaming-audio/change-offer/radio-change-offer.module').then((m) => m.RadioChangeOfferModule),
      },
      {
        path: 'support_premium',
        loadChildren: () =>
          import('./support-premium/support-premium/support-premium.module').then((m) => m.SupportPremiumModule),
      },
      {
        path: 'support_premium_change_offer',
        loadChildren: () =>
          import('./support-premium/support-premium-change-offer/support-premium-change-offer.module').then(
            (m) => m.SupportPremiumChangeOfferModule
          ),
      },
      {
        path: 'hosting_change_offer',
        loadChildren: () =>
          import('./hosting-web/hosting-web-change-offer/hosting-web-change-offer.module').then(
            (m) => m.HostingWebChangeOfferModule
          ),
      },
    ],
  },
];

@NgModule({
  declarations: [SelectionComponent],
  imports: [RouterModule.forChild(routes), CommonModule, NgxsModule.forFeature([CartState])],
  exports: [SelectionComponent],
})
export class SelectionModule {}
